
import { FormControl, Box, FormHelperText, TextField } from '@mui/material';

interface AuditNameFieldProps {
  value: string;
  error: boolean | string;
  setValue: (value: string) => void;
  setError: (error: boolean | string) => void;
  setChanged: () => void;
  [key: string]: unknown;
}

export default function AuditNameField({
  value,
  error,
  setValue,
  setError,
  setChanged,
  ...rest
}: AuditNameFieldProps): React.JSX.Element {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value: newValue } = event.target;
    setValue(newValue);
    setChanged();
    if (/[#^$<>+%!`&*'"|{}?/\\:=@]/.test(newValue)) {
      setError('Name cannot contain #^$<>+%!`&*\'"|{}?/\\:=@');
    } else if (newValue === '') {
      setError('Name cannot be blank');
    } else {
      setError(false);
    }
  };

  return (
    <Box>
      <FormControl fullWidth required>
        <TextField
          {...rest}
          label='Name'
          id='name'
          aria-describedby='name-helper-text'
          onChange={handleChange}
          error={Boolean(error)}
          value={value}
          variant='standard'
          required
        />
        {error ? (
          <FormHelperText id='name-helper-text'>{error}</FormHelperText>
        ) : (
          <FormHelperText id='name-helper-text'>
            Enter the name of the audit.
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
}

